// Billing Add Credits
export const BILLING_ADD_CREDITS_REQUEST = 'BILLING_ADD_CREDITS_REQUEST';
export const BILLING_ADD_CREDITS_DONE = 'BILLING_ADD_CREDITS_DONE';
export const BILLING_ADD_CREDITS_FAILED = 'BILLING_ADD_CREDITS_FAILED';
export const BILLING_ADD_CREDITS_RESET = 'BILLING_ADD_CREDITS_RESET';